<template>
  <SfModal
    visible
    :title="$t('This item is currently out of stock.')"
    :white-background="true"
    @close="closeModal"
  >
    <div
      class="alternative-products-modal__bar overflow-auto"
    >
      <div class="flex flex-1 flex-col h-full gap-4">
        <div class="text-EXPONDO-grey text-lg leading-7 text-center">
          {{ $t('Recommended alternatives, selected based on your interest:') }}
        </div>
        <div class="w-full h-full">
          <div class="w-full h-full">
            <div class="relative w-full max-w-full gap-4">
              <SimpleCarousel
                class="h-full"
                :slider-items="productsData"
                slide-class="flex-1 justify-center"
                height="100%"
                :arrows="true"
                :should-scroll-to-slide-on-open="true"
                slides-auto-width
                :has-controls-outside-container="false"
              >
                <template #default="{ currentItem }">
                  <div class="flex flex-col min-w-[176px] w-72 px-2">
                    <CustomLink
                      :url="currentItem.product._slug"
                      :type="LINK_TYPE.NoStyle"
                    >
                      <TwicpicsImage
                        :src="currentItem.product.images[0].url"
                        :alt="currentItem.product._name"
                        :width="240"
                        :height="240"
                        class="max-h-60"
                      />
                    </CustomLink>

                    <div class="top-0 bg-white z-[2]">
                      <CustomLink
                        :url="currentItem.product._slug"
                        :type="LINK_TYPE.NoStyle"
                      >
                        <AlternativeProductDetails
                          :product="currentItem.product"
                          :current-sku="currentSku"
                        />
                      </CustomLink>
                      <div class="absolute shadow-bottom bottom-0 w-full h-1" />
                    </div>
                  </div>
                </template>
              </SimpleCarousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </SfModal>
</template>

<script lang="ts">

import type { AlternativeProductData } from '~~/types/product/AlternativeProducts';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';

export default defineComponent({
  name: 'AlternativeProducts',

  props: {
    productsData: {
      type: Array as PropType<AlternativeProductData[]>,
      required: true,
    },
    currentSku: {
      type: String,
      required: true,
    },
  },
  emits: ['close'],
  setup(_props, { emit }) {

    const closeModal = () => {

      emit('close');
    
    };

    return {
      LINK_TYPE,
      closeModal,
    };
  
  },
});


</script>
